import toInteger from 'lodash/toInteger';

import { getZpl } from 'label/LabelPrintTemplate';
import {
  LabelSize,
  LabelData,
  LabelMargins,
  BarcodeDisplayOptions,
  BarcodeTypes,
  LabelContent,
} from 'label/utils/types';
import SocketClient from 'pages/views/devices/socketClient';
import {
  PRINTER_MESSAGES,
  PRINTER_KINDS,
  PRINTER_FORMATS,
} from 'pages/views/devices/socketClient/types';

const MAX_PAYLOAD_SIZE = 63_000;

export function sendLabelToHub({
  labelSize,
  labelData,
  labelMargins,
  labelQuantity,
  isListOfLabels,
  displayPrice,
  barcodeDisplayOption,
  barcodeType,
  labelContent,
  dateNow,
}: {
  labelSize: LabelSize;
  previousLabelSize?: string | undefined;
  labelData: LabelData[];
  labelMargins: LabelMargins;
  labelQuantity: number;
  isListOfLabels: boolean;
  displayPrice: boolean;
  barcodeDisplayOption: BarcodeDisplayOptions;
  barcodeType: BarcodeTypes;
  labelContent: LabelContent | null;
  dateNow: string | undefined;
}) {
  const executionTimes: Record<string, number> = {
    RETAIL_PRINT_START: Date.now(),
  };

  const chunks = labelData.reduce(
    (accumulator, item, index) => {
      const nextZplString = getZpl({
        setHeaderCommands: !index,
        labelData: item,
        labelMargin: labelMargins[labelSize],
        labelQuantity: isListOfLabels ? toInteger(item.copies) : labelQuantity,
        labelSize,
        displayPrice,
        barcodeDisplayOption,
        barcodeType,
        labelContent,
        dateNow,
      });

      // Ably will only allow a max payload of 64kb, if the message size approaches the limit, split the payload across multiple messages
      const previousChunk = accumulator[accumulator.length - 1];

      // Check if the previous chunk plus the next chunk is too large, if so start a new chunk on the end
      if (previousChunk.length + nextZplString.length > MAX_PAYLOAD_SIZE) {
        accumulator.push(nextZplString);
      } else {
        accumulator[accumulator.length - 1] = previousChunk.concat(nextZplString);
      }

      return accumulator;
    },
    ['']
  );

  executionTimes.RETAIL_ZPL_GENERATED = Date.now();

  chunks.forEach(zplData => {
    SocketClient.send(PRINTER_MESSAGES.PRINT, {
      data: zplData,
      kind: PRINTER_KINDS.LABEL,
      size: labelSize,
      format: PRINTER_FORMATS.ZPL,
      executionTimes,
    });
  });
}
